import React from "react";
import styles from "./PastilleIcon.module.css";

const PastilleIcon: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <div className={styles.icon}>{children}</div>;
};

export default PastilleIcon;
